const workdata = {
  state: {
    exampal_work_url: "", //课堂作品完整版
    home_template_url: "", //课程引导
    teach_template_url: "", //授课空模板
    course_work_url: "", //课堂作品
    home_work_url: "",   //课后作品
    teach_work_url: "", //老师课堂作品

  },
  mutations: {

    SET_COURSE_WORK_URL: (state, data) => {
      state.course_work_url = data;
      localStorage.setItem('course_work_url', data);
    },
    RESET_COURSE_WORK_URL: (state) => {
      state.course_work_url = "";
    },

    SET_TEACH_WORK_URL: (state, data) => {
      state.teach_work_url = data;
      localStorage.setItem('teach_work_url', data);
    },
    RESET_TEACH_WORK_URL: (state) => {
      state.teach_work_url = "";
    },


    SET_HOME_WORK_URL: (state, data) => {
      state.home_work_url = data;
      localStorage.setItem('home_work_url', data);
    },
    RESET_HOME_WORK_URL: (state) => {
      state.home_work_url = "";
    },

    SET_EXAM_WORK_URL: (state, data) => {
      state.exampal_work_url = data;
      localStorage.setItem('exampal_work_url', data);
    },
    RESET_EXAM_WORK_URL: (state) => {
      state.exampal_work_url = "";
    },

    SET_HOME_TEMPLATE_URL: (state, data) => {
      state.home_template_url = data;
      localStorage.setItem('home_template_url', data);
    },
    RESET_HOME_TEMPLATE_URL: (state) => {
      state.home_template_url = "";
    },

    SET_TEACH_TEMPLATE_URL: (state, data) => {
      state.teach_template_url = data;
      localStorage.setItem('teach_template_url', data);
    },
    RESET_TEACH_TEMPLATE_URL: (state) => {
      state.teach_template_url = "";
    },
  },
  actions: {
  }
};

export default workdata;